<template>
	<section class="contact-us">
		<div class="contact-main">
			<div class="contact-form">
				<h2 class="font-34">{{ $fn.tr('Leave You Feedback') }}</h2>
				<form v-if="!showSuccessMessage">
					<div class="input">
						<input
							:class="contact.name ? 'filled' : ''"
							type="text"
							v-model="contact.name"
							name="name"
							id="name"
						/>
						<label for="name"
							><p>{{ $fn.tr('Type Name') }} <span>*</span></p></label
						>
						<p
							class="font-12 dejavusans error"
							:class="_.get(contact, 'name').length < 3 && clicked ? 'show' : ''"
						>
							{{ $fn.tr('validate first name') }}
						</p>
					</div>
					<div class="input">
						<input
							@keypress="validateEmail(contact.email)"
							:class="contact.email ? 'filled' : ''"
							v-model="contact.email"
							type="email"
							name="email"
							id="email"
						/>
						<label for="email"
							><p>{{ $fn.tr('Email Address') }} <span>*</span></p></label
						>
						<p
							class="font-12 dejavusans error"
							:class="!validateEmail(contact.email) && clicked ? 'show' : ''"
						>
							{{ $fn.tr('validate email') }}
						</p>
					</div>
					<div class="input">
						<input
							:class="contact.subject ? 'filled' : ''"
							type="text"
							v-model="contact.subject"
							name="subject"
							id="subject"
						/>
						<label for="subject"
							><p>{{ $fn.tr('Subject') }} <span>*</span></p></label
						>
						<p
							class="font-12 dejavusans error"
							:class="_.get(contact, 'subject').length < 3 && clicked ? 'show' : ''"
						>
							{{ $fn.tr('validate subject') }}
						</p>
					</div>
					<div class="input">
						<textarea
							style="resize: none;"
							:class="contact.message ? 'filled' : ''"
							v-model="contact.message"
							type="text"
							name="message"
							id="message"
						/>
						<label for="message"
							><p>{{ $fn.tr('You Text Here') }} <span>*</span></p></label
						>
						<p
							class="font-12 dejavusans error"
							:class="_.get(contact, 'message').length < 8 && clicked ? 'show' : ''"
						>
							{{ $fn.tr('validate message') }}
						</p>
					</div>
					<div class="submit-div">
						<VueRecaptcha
							:sitekey="siteKey"
							:loadRecaptchaScript="true"
							@verify="onVerify"
						></VueRecaptcha>

						<button class="relative submit-button" @click.prevent="sendFormData()">
							<IconComponent name="arrow-right" />
							{{ $fn.tr('send') }}
						</button>
					</div>
				</form>
				<div class="success-mesage" v-if="showSuccessMessage">
					<h3 class="font-34 f-medium">{{ $fn.tr('Sent Successfully') }}</h3>
				</div>
			</div>
			<div class="map-content">
				<div class="contact-info">
					<div class="text contact-editor" v-html="_.get(footerInfo, 'address')"></div>
					<div class="text contact-editor" v-html="_.get(footerInfo, 'details')"></div>
				</div>

				<GmapMap
					class="map"
					:center="center"
					:zoom="17"
					ref="mapRef"
					:options="{
						styles: darkTheme,
						zoomControl: true,
						gestureHandling: 'cooperative',
					}"
				>
					<GmapMarker
						:clickable="true"
						:icon="marker"
						:position="{
							lat: widgetLat,
							lng: widgetLng,
						}"
					>
					</GmapMarker>
				</GmapMap>
			</div>
		</div>
	</section>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import { gmapApi } from 'vue2-google-maps';
import IconComponent from '../IconComponent.vue';

export default {
	components: {
		VueRecaptcha,
		IconComponent,
	},
	data() {
		return {
			contact: {
				name: '',
				email: '',
				subject: '',
				message: '',
			},
			clicked: false,
			showSuccessMessage: false,
			marker: 'https://d.radikal.ru/d07/2110/74/ad40fa0d2bb9.png',
			captchaVerify: false,
			generatedCatchaKey: '',

			darkTheme: [
				{ elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
				{ elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
				{ elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
				{
					featureType: 'administrative.locality',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#d59563' }],
				},
				{
					featureType: 'poi',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#d59563' }],
				},
				{
					featureType: 'poi.park',
					elementType: 'geometry',
					stylers: [{ color: '#263c3f' }],
				},
				{
					featureType: 'poi.park',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#6b9a76' }],
				},
				{
					featureType: 'road',
					elementType: 'geometry',
					stylers: [{ color: '#38414e' }],
				},
				{
					featureType: 'road',
					elementType: 'geometry.stroke',
					stylers: [{ color: '#212a37' }],
				},
				{
					featureType: 'road',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#9ca5b3' }],
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry',
					stylers: [{ color: '#746855' }],
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry.stroke',
					stylers: [{ color: '#1f2835' }],
				},
				{
					featureType: 'road.highway',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#f3d19c' }],
				},
				{
					featureType: 'transit',
					elementType: 'geometry',
					stylers: [{ color: '#2f3948' }],
				},
				{
					featureType: 'transit.station',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#d59563' }],
				},
				{
					featureType: 'water',
					elementType: 'geometry',
					stylers: [{ color: '#17263c' }],
				},
				{
					featureType: 'water',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#515c6d' }],
				},
				{
					featureType: 'water',
					elementType: 'labels.text.stroke',
					stylers: [{ color: '#17263c' }],
				},
			],

			center: {
				lat: this.widgetLat,
				lng: this.widgetLng,
			},

			swiperOptions: {
				watchOverflow: true,
				slidesPerView: 'auto',
				freeMode: true,
				spaceBetween: 10,
				speed: 1000,
				breakpoints: {},
			},
		};
	},
	mounted() {
		this.$refs.mapRef.$mapPromise.then((map) => {
			map.panTo({
				lat: this.widgetLat,
				lng: this.widgetLng,
			});
		});
	},
	computed: {
		footerInfo() {
			return _.get(this.$store.state.main.indx, 'widgets.contact_info');
		},
		widgetLat() {
			return parseFloat(_.get(this.footerInfo, 'map-lat'));
		},
		widgetLng() {
			return parseFloat(_.get(this.footerInfo, 'map-lon'));
		},
		siteKey() {
			console.log(_.get(this.$store.state.main.indx, 'siteSettings.captcha_key'), 'keysite');
			return _.get(this.$store.state.main.indx, 'siteSettings.captcha_key');
		},
	},
	methods: {
		validateEmail(email) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
		},
		onVerify(res) {
			this.generatedCatchaKey = res;
			this.captchaVerify = true;
		},

		sendFormData: async function() {
			this.clicked = true;
			if (
				this.captchaVerify &&
				_.get(this.contact, 'name').length > 2 &&
				_.get(this.contact, 'subject').length > 3 &&
				_.get(this.contact, 'message').length > 8 &&
				this.validateEmail(this.contact.email)
			) {
				let formData = {};
				formData.name = this.contact.name;
				formData.email = this.contact.email;
				formData.subject = this.contact.subject;
				formData.message = this.contact.message;
				formData.captchaKey = this.generatedCatchaKey;
				formData.formType = 'contact';
				let tmp = await this.$fn.postData('main/contactform', formData);
				if (tmp.status == 200) {
					this.contact.name = '';
					this.contact.email = '';
					this.contact.subject = '';
					this.contact.message = '';
					this.generatedCatchaKey = '';
					this.clicked = false;
					this.captchaVerify = false;
					this.showSuccessMessage = true;
					setTimeout(() => {
						this.showSuccessMessage = false;
					}, 6000);
				}
			}
		},
	},
};
</script>

<style lang="scss">
.contact-us {
	background: var(--thirdy-tranparent);
	padding: 30px 0 0 30px;
	@media (max-width: 1365px) {
		padding: 30px 35px 0 16px;
	}
	@media (max-width: 767px) {
		padding: 30px 20px 0;
	}
	.contact-main {
		display: flex;
		@media (max-width: 1365px) {
			flex-direction: column-reverse;
		}
		.contact-form {
			width: calc(50% - 15px);
			@media (max-width: 1365px) {
				width: 100%;
			}
			margin-right: auto;
			h2 {
				color: var(--bonus-txt);
				width: fit-content;
				margin-bottom: 15px;
				margin-top: 63px;
			}
			p {
				color: var(--bonus-txt);
			}
			form {
				margin: 55px 0;
				.input {
					position: relative;
					margin-bottom: 20px;
					label {
						position: absolute;
						width: 100%;
						left: 60px;
						top: 30px;
						pointer-events: none;
						transition: 0.4s ease-in-out;
						p {
							color: var(--formText);
						}
						&::before {
							content: '';
							position: absolute;
							width: 2px;
							border-radius: 3px;
							height: 25px;
							top: 0;
							left: -30px;
							background: var(--formText);
						}
						span {
							color: var(--red-txt);
						}
					}
					input,
					textarea {
						border: 1px solid var(--white-txt);
						width: 100%;
						height: 80px;
						background: var(--white-bg);
						padding: 27px 30px 27px 60px;
						color: var(--bonus-txt);
						&:focus {
							border: 1px solid var(--primary-txt);
						}
						&:focus + label,
						&.filled + label {
							&::before {
								transition: 0.4s ease-in-out;
								background: var(--red-txt);
							}
							p {
								opacity: 0;
							}
						}
					}
					textarea {
						height: auto;
						min-height: 233px;
					}
					.error {
						color: var(--red);
						margin-top: 0px;
						padding-left: 30px;
						opacity: 0;
						max-height: 0;
						transition: 0.4s ease;
					}
					.error.show {
						opacity: 1;
						margin-top: 10px;
						max-height: 60px;
						transition: 0.4s ease;
					}
				}
				.submit-div {
					margin-top: 30px;
					display: flex;
					justify-content: space-between;
					@media (max-width: 1365px) {
						flex-direction: column;
					}
					.kaptcha {
						width: 303px;
						height: 76px;
						border: 1px solid;
						@media (max-width: 1365px) {
							width: 100%;
						}
					}
					.submit-button {
						@include defBut(
							var(--primay-button-bg),
							var(--bonus-txt3),
							var(--secondarty-transparent),
							var(--white-button-txt2)
						);
						display: flex;
						align-items: center;
						justify-content: center;
						height: 76px;
						padding: 0 50px;
						cursor: pointer;
						svg {
							margin-right: 10px;
							margin-top: 5px;
							path {
								fill: var(--white-button-txt2) !important;
							}
						}
						@media (max-width: 1365px) {
							margin-top: 34px;
						}
					}
				}
			}
			.success-mesage {
				// position: fixed;
				// bottom: 5%;
				// right: 5%;
				// border-radius: 20px;
				// background: var(--white-bg);
				// border: 1px solid var(--white-txt);
				padding: 55px 0px;
				h3 {
					color: var(--bonus-txt);
				}
			}
		}
		.map-content {
			width: calc(50% - 15px);
			.contact-editor {
				h2 {
					margin-bottom: 15px;
				}
				p {
					margin-bottom: 8px;
					word-break: break-word;
				}
				a {
					word-break: break-word;
				}
			}
			.map {
				margin-top: 35px;
				width: 100%;
				height: 754px;
				div {
					transition: unset;
				}
				@media (max-width: 1599px) {
					height: 691px;
				}
				@media (max-width: 1439px) {
					height: 700px;
				}
				@media (max-width: 1365px) {
					height: 377px;
					margin-bottom: 55px;
				}
				@media (max-width: 767px) {
					height: 490px;
				}
			}
			@media (max-width: 1365px) {
				width: 100%;
			}
			margin-left: auto;
			.contact-info {
				display: flex;
				max-width: 95%;
				@media (max-width: 549px) {
					flex-direction: column;
				}
				.text {
					h2 {
						font-size: 21px;
					}
					color: var(--bonus-txt);
					width: 50%;
					@media (max-width: 549px) {
						width: 100%;
						&:nth-child(2) {
							margin-top: 34px;
						}
					}
				}
			}
		}
	}
}
</style>
